import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { navigation } from '../constants/navigation'
import { useState } from 'react'

const Logo = require('../../img/drippy_rugs_logo_320x320.png')

const firstRow = navigation.filter((item, index) => index < 3 && item.showNav)
const secondRow = navigation.filter((item, index) => index >= 3 && item.showNav)

export default function Navigation() {
    const location = useLocation()
    const [loaded, setLoaded] = useState(false)

    const handleImgLoaded = () => setLoaded(true)

    return (
        <nav
            id="navigation"
            className="w-full max-w-screen-md flex flex-col items-center justify-center pt-4"
        >
            <Link to="/">
                <h1 className="relative block w-[160px] [h-160px] hover:glow hover:animate-shake duration-200">
                    <img
                        src={Logo}
                        alt="@drippy_rugs logo"
                        width={160}
                        height={160}
                        className={`${
                            loaded ? 'opacity-100' : 'opacity-0'
                        } duration-500`}
                        onLoad={handleImgLoaded}
                    />
                </h1>
            </Link>
            <ul className="hidden sm:flex gap-4 max-w-md text-2xl font-heading mt-4">
                {firstRow.map((item) => (
                    <li key={item.href}>
                        <Link
                            to={item.href}
                            className={`hover:text-red-600 duration-200 select-none
                                ${
                                    item.href === location.pathname
                                        ? 'text-red-600'
                                        : 'text-white'
                                }
                            `}
                        >
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
            <ul className="hidden sm:flex gap-4 max-w-md text-2xl font-heading">
                {secondRow.map((item) => (
                    <li key={item.href}>
                        <Link
                            to={item.href}
                            className={`hover:text-red-600 duration-200 select-none
                                ${
                                    item.href === location.pathname
                                        ? 'text-red-600'
                                        : 'text-white'
                                }
                            `}
                        >
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    )
}
